import logo from "../../assets/images/logo.svg";
import WelcomeList from "../../components/landingPage/WelcomeList";

function LandingPage() {
  return (
    <div className="md:flex w-screen md:h-screen bg-white">
      <div className="invisible md:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
        <img
          className="  absolute md:top-10 md:left-20"
          src={logo}
          alt="GIGM Logo"
        />
        <div className="text-4xl">
          <h1>It’s easier to get</h1>
          <h2 className="inline">started with{` `}</h2>
          <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
        </div>
      </div>
      <img className="ml-20 md:hidden" src={logo} alt="GIGM Logo" />
      <div className=" items-center justify-center ">
        <WelcomeList />{" "}
      </div>
    </div>
  );
}

export default LandingPage;
